import { usePresenceTransition } from '@/shared/hooks/usePresenceTransition';

type DropdownListener = (openDropdownId: string | null) => void;

const listeners = new Set<DropdownListener>();
let activeDropdownId: string | null = null;
export const CLOSE_ALL_DROPDOWNS_ID = '__close_all_dropdowns__';
export const DROPDOWN_MOTION_DURATION_MS = 320;

const emit = () => {
  listeners.forEach((listener) => listener(activeDropdownId));
};

export const subscribeDropdownCoordinator = (listener: DropdownListener) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export const announceDropdownOpen = (dropdownId: string) => {
  activeDropdownId = dropdownId;
  emit();
};

export const announceDropdownClosed = (dropdownId: string) => {
  if (activeDropdownId !== dropdownId) {
    return;
  }

  activeDropdownId = null;
  emit();
};

export const closeAllDropdowns = () => {
  activeDropdownId = CLOSE_ALL_DROPDOWNS_ID;
  emit();
};

export const useDropdownTransition = (isOpen: boolean, duration = 160) =>
  usePresenceTransition(isOpen, { activationFrames: 1, duration });
